import { Icon } from "@nju/icons";
import { Button, Loader } from "@nju/ui";

interface IComboboxSuffixProps {
  isLoading: boolean;
  isCountrySelected: boolean;
  onClearCountry: () => void;
}

export function ComboboxSuffix({
  isLoading,
  isCountrySelected,
  onClearCountry,
}: IComboboxSuffixProps) {
  if (isLoading) {
    return <Loader />;
  }

  if (isCountrySelected) {
    return (
      <Button
        display="inline"
        onPress={onClearCountry}
        size="inline"
        variant="simple"
      >
        <Icon height={24} name="times" width={24} />
      </Button>
    );
  }

  // eslint-disable-next-line unicorn/no-null
  return null;
}
